import React, { useState } from 'react';
import { Grid, Box, TextField, Button, Typography, Paper, Alert } from '@mui/material';
import config from '../../js/config';
import MicrosoftSSO from '../../components/icons/MicrosoftSSO';

const LoginPage = () => {
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');

  const handleLogin = async () => {
    setError('');
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);

    try {
      const response = await fetch(config.data_platform_api_url + '/auth/generic/login', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        const token = data.access_token;

        // Redirect to the stored path or a default one
        const returnTo = localStorage.getItem('returnTo') || '/app/dataplatform/logs';
        localStorage.removeItem('returnTo'); // Clean up after use

        const url = new URL(window.location.origin + returnTo);
        url.searchParams.set('token', token);
        window.location.href = url.toString();
      } else {
        const errorData = await response.json().catch(() => ({ detail: 'Login failed. Please check your credentials.' }));
        setError(errorData.detail || 'Login failed. Please check your credentials.');
      }
    } catch (error) {
      setError('An unexpected error occurred. Please try again.');
      console.error('Error:', error);
    }
  };

  const handleMicrosoftLogin = async () => {
    const returnTo = localStorage.getItem('returnTo') || '/app/dataplatform/logs';
    localStorage.setItem('returnTo', returnTo); // Ensure it's set for the callback
    const encodedState = btoa(JSON.stringify({ returnTo }));
    window.location.href = `${window.location.origin}/api/auth/microsoft/login?state=${encodedState}`;
  }
  const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleLogin();
    }
  };

  React.useEffect(() => {
    window.addEventListener('keypress', handleKeyPress);
    return () => {
      window.removeEventListener('keypress', handleKeyPress);
    };
  }, [username, password]);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ height: '100vh' }}
    >
      <Grid item xs={10} sm={8} md={6} lg={4} xl={3}>
        <Paper elevation={6} sx={{ padding: 4, borderRadius: 2 }}>
          <Typography variant="h4" align="center" gutterBottom>
            Login
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TextField
            fullWidth
            label="Username"
            variant="outlined"
            margin="normal"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              setError('');
            }}
            autoFocus
          />
          <TextField
            fullWidth
            label="Password"
            variant="outlined"
            margin="normal"
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError('');
            }}
          />
          <Box sx={{ textAlign: 'center', mt: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleLogin}
              sx={{ minWidth: '120px' }}
            >
              Login
            </Button>
            <Box sx={{ textAlign: 'center', mt: 2 }}>
              <MicrosoftSSO onClick={handleMicrosoftLogin} />
            </Box>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default LoginPage;